/* eslint-disable max-len */
export default {
  title: '情報セキュリティー基本方針',
  desc: '飛狼*は、デザインと技術にこだわり、細部まで丁寧に創りこんだプロダクトで、ユーザーに最高の体験を提供することに力を注いでいます。\n'
      + '飛狼*は、お客様や社会からの信頼に応える持続可能な企業を目指す為に、当社が保有する情報資産を適切に保護し、消失・盗難・不正使用・漏えいを防止する目的で、情報セキュリティ管理システムを導入します。情報セキュリティ管理を経営上の最重要課題の一つと位置付け、情報セキュリティ基本方針を策定し、情報セキュリティの維持および向上を業務活動における重要な使命としています。',
  signature: '*飛狼は中国国内のグループ企業（成都市飛狼科技有限公司、大連飛狼科技有限公司、飛狼数碼（上海）有限公司）の統一名称です。',
  list: [
    {
      title: '情報セキュリティ体制の構築',
      desc: '情報セキュリティ管理システムを構築、実施、維持し、継続的な改善を図ります。',
    },
    {
      title: '情報資産の管理と保護',
      desc: '体系的なリスク管理手法を採用し、情報セキュリティリスクを特定、評価、対処していきます。',
    },
    {
      title: '情報セキュリティ教育',
      desc: 'すべての従業員が情報資産保護における自身の役割と責任を理解するよう、定期的に情報セキュリティの研修や啓発活動を実施します。これにより、製品やサービスの安全性を確保し、顧客やビジネスパートナーの情報、ならびに当社の技術情報などの重要な情報を保護します。',
    },
    {
      title: '法令・規範の遵守',
      desc: '事業を展開する国や地域における適用される情報セキュリティ関連の法律および規範、並びに顧客やビジネスパートナーとの契約を遵守します。',
    },
    {
      title: '継続的改善',
      desc: '定期的に情報セキュリティ管理システムのパフォーマンスを見直し、評価することで、改善の機会を特定し、情報セキュリティ管理の水準を継続的に向上させることを約束します。',
    },
  ],
};
